<template src="./html/Datatable.html"></template>

<script>
	import swal from 'sweetalert2'
	import Vuetable from 'vuetable-2/src/components/Vuetable'
	import VuetablePaginationInfo from 'vuetable-2/src/components/VuetablePaginationInfo'
	import VuetablePagination from 'vuetable-2/src/components/VuetablePagination'

	import FilterBar from './FilterBar'
	import Create from './Create'
	import Items from './Items'
	import VueElementLoading from 'vue-element-loading'

	export default {
		props: ['isAuth', 'user', 'agreement'],
		components: {
			'datatable': Vuetable,
			'pagination-info': VuetablePaginationInfo,
			'pagination': VuetablePagination,

			'filter-bar': FilterBar,
			'create': Create,
			'items': Items,
			'loading': VueElementLoading,
		},
		data () {
			return {
				perPages: [
					{
						label: 20,
						value: 20,
					},
					{
						label: 50,
						value: 50,
					},
					{
						label: 100,
						value: 100,
					},
					{
						label: 'Todo',
						value: null,
					},
				],
				datatable: {
					api: this.$env.ROOT + '/api/' + this.$lang.getLang() + '/admin/recurrings/datatable',
					loading: true,
					moreParams: {
						filter: {
							text: null,
							allowDate: false,
							date: null,
							agreement_id: null,
						},
					},
					page: 100,
					path: '',
					sortOrder: [
						{
							field: 'created_at',
							sortField: 'created_at',
							direction: 'desc',
						}
					],
					options: {
						headers: {
							'Authorization': 'Bearer ' + this.$auth.getToken()
						}
					},
					css: {
						table: {
							sortableIcon: 'fa fa-sort',
							tableClass: 'table table-hover table-striped table-condensed',
							ascendingIcon: 'fa fa-caret-up',
							descendingIcon: 'fa fa-caret-down',
						},
						pagination: {
							wrapperClass: "pagination pull-right",
							activeClass: "btn-default disabled",
							disabledClass: "disabled",
							pageClass: "btn btn-default",
							linkClass: "btn btn-default",
							icons: {
								first: "fa fa-fast-backward",
								prev: "fa fa-step-backward",
								next: "fa fa-step-forward",
								last: "fa fa-fast-forward",
							}
						},
					},
					fields: [
						{
							name: '__slot:id',
							title: this.$platform.setting.number_symbol,
							sortField: 'id',
						},
						{
							name: '__slot:interval',
							title: 'Intervalo',
						},
						{
							name: '__slot:type',
							title: 'Documento',
						},
						{
							name: '__slot:start',
							title: 'Inicio',
							sortField: 'start',
						},
						{
							name: '__slot:end',
							title: 'Fin',
							sortField: 'end',
						},
						{
							name: '__slot:next',
							title: 'Próximo',
						},
						{
							name: '__slot:status',
							title: 'Estado',
						},
						{
							name: '__slot:author',
							title: 'Autor',
							sortField: 'author_id',
						},
						{
							name: 'created_at',
							title: 'Fecha',
							sortField: 'created_at',
							callback: function(value) {
								return moment(value).format('DD/MM/YY H:mm')
							},
						},
						{
							name: '__slot:actions',
							title: '',
						},
					],
				},

				statuses: null,
			}
		},
		mounted() {
			this.$events.$on('filterSet', eventData => this.filterSet(eventData))
			this.$events.$on('filterReset', eventData => this.filterReset(eventData))
		},
		created() {
			if(this.agreement) {
				this.datatable.moreParams.filter.agreement_id = this.agreement.id
			}
			this.init()
		},
		methods: {
			init() {
				this.getStatuses()
			},
			getStatuses() {
				this.$http.get('admin/agreements/statuses')
				.then(response => {
					this.statuses = response.body
				})
			},
			reload() {
				this.$nextTick( () => this.$refs.datatable.refresh())
			},
			normalizeFields() {
				this.$nextTick( () => this.$refs.datatable.normalizeFields())
			},
			loading() {
				this.datatable.loading = true
			},
			loaded() {
				this.datatable.loading = false
			},
			onPaginationData (paginationData) {
				this.$refs.paginationInfo.setPaginationData(paginationData)
				this.$refs.pagination.setPaginationData(paginationData)
			},
			onChangePage (page) {
				this.$refs.datatable.changePage(page)
			},
			filterSet: _.debounce(function (filter) {
				this.datatable.moreParams.filter = filter
				if(this.$refs.datatable) {
					this.$nextTick( () => this.$refs.datatable.refresh())
				}
			}, 300),
			filterReset(filter) {
				this.datatable.moreParams.filter = filter
				if(this.$refs.datatable) {
					this.$nextTick( () => this.$refs.datatable.refresh())
				}
			},
			//--
			destroy: function(recurring) {
				var that = this
				swal.queue([{
					title: that.$t("messages.attention"),
					text: that.$t("messages.item_can_not_be_retrieved"),
					type: "warning",
					showCancelButton: true,
					confirmButtonColor: "#53e69d",
					cancelButtonColor: "#ff7676",
					confirmButtonText: "Si",
					cancelButtonText: "No",
					showLoaderOnConfirm: true,
					preConfirm: function () {
						return new Promise(function (resolve) {
							that.$http.delete('admin/recurrings/' + recurring.id)
							.then(response => {
								that.reload()
								swal(response.body.title, response.body.text, response.body.type);
							}).catch(function(response) {
								if(response.status == 409) {
									swal(response.body.title, response.body.text, response.body.type);
								} else {
									swal({
										title: response.statusText,
										text: response.body,
										type: "warning"
									});
								}
							})
						})
					}
				}]).catch(swal.noop)
			},
		},
	}
</script>


// WEBPACK FOOTER //
// src/components/agreements/components/recurrings/views/Datatable.vue